import toast from "react-hot-toast";
import { ReactComponent as Check } from "../assets/icons/check-mark.svg";
import { ReactComponent as Cross } from "../assets/icons/x.svg";

type ToastType = "success" | "error" | "warning";

const TOAST_STYLES: Record<ToastType, { bg: string; border: string; text: string; iconClass: string }> = {
  success: {
    bg: "bg-[rgba(157,238,190,1)]",
    border: "border-[rgba(157,238,190,1)]",
    text: "text-content-primary",
    iconClass: "",
  },
  warning: {
    bg: "bg-pink-100",
    border: "border-pink-200",
    text: "text-pink-700",
    iconClass: "[&>path]:stroke-pink-600",
  },
  error: {
    bg: "bg-red-100",
    border: "border-red-100",
    text: "text-red-500",
    iconClass: "[&>path]:stroke-red-600",
  },
};

export function ShowToast({
  message,
  note,
  type,
  duration = 4000,
}: {
  message: string;
  /** Optional secondary line, rendered small + italic + muted beneath the message. */
  note?: string;
  type: ToastType;
  duration?: number;
}) {
  const styles = TOAST_STYLES[type];

  toast.custom(
    (_t) => (
      <div
        className={`z-[99999] md:max-w-[70vw] pl-3 pr-4 py-2.5 ${styles.bg} rounded border ${styles.border} border-opacity-20 justify-start ${note ? "items-start" : "items-center"} gap-1.5 inline-flex`}
      >
        {type === "success" ? (
          <Check className="w-6 h-4 relative shrink-0 [&_path]:!stroke-[#11845B]" />
        ) : (
          <Cross className={`w-5 h-5 relative shrink-0 ${styles.iconClass}`} />
        )}
        <div className="flex flex-col gap-0.5">
          <div
            className={`${styles.text} text-sm font-medium leading-normal whitespace-pre-wrap`}
          >
            {message}
          </div>
          {note && (
            <div
              className={`${styles.text} text-xs font-normal italic leading-snug opacity-70 whitespace-pre-wrap`}
            >
              {note}
            </div>
          )}
        </div>
      </div>
    ),
    { duration }
  );
}
